/* eslint-disable */

// This is required for GA4
window.dataLayer = window.dataLayer || [];

(function (window, document) {

  // defaultConfig is a default configuration and can be altered, but is
  // not mandatory. The player comes with a default configuration already,
  // preset with values that I have added when setting up the online player
  // which is referenced in the player link.
  // The configuration below can be used as an application wide configuration
  // to override the default settings of the player.
  // Note that any settings on the instance of the player as seen in
  // the html document will override these values.
  var defaultConfig = {
    // autoPause ensures the video is paused if the player is not in
    // the viewable area. This is mandatory to be enabled.
    autoPause: { viewability: true },
    controls: true,
    autostart: false,
    mute: false,
    // this ga4analytics feature is custom and does not come from JWPlayer.
    ga4analytics: true,
    repeat: false,
    logo: false,
    sharing:
    {
      sites: [
        'facebook',
        'twitter',
        'linkedin',
        'email'
      ]
    },

  };

  // This function contains the required features
  function setupVideoPlayer(elementId, instanceConfig) {

    if (typeof jwplayer !== 'function') {
      throw new Error('jwplayer() not available');
    }
    var container = document.getElementById(elementId);
    if (!container) {
      throw new Error('No element with id "' + elementId + '"');
    }

    // Fetch the config
    var config = Object.assign({}, defaultConfig, instanceConfig);

    // Create the player based on the playername chosen where the player is called
    var player = jwplayer(elementId).setup(config);

    // To keep track of what play it is is looping
    var currentPlay = 0;

    // If the progress bar passes a treshold where we dont end up in an
    // exact 25, 50 or 75 value, we need to rather check if we pass a quartile
    // treshold rather than an exact number. E.g. if percentage go from 49%
    // to 51% we will not fail sending 50% progress.
    var firedQ = { 25: false, 50: false, 75: false };

    // Occasionally start can be trigged twice, this is to safeguard against
    // those occasions.
    var startFired = false;

    // Ensure initial values are correct on player ready
    player.on('ready', function () {
      startFired = false;
      firedQ = { 25: false, 50: false, 75: false };
    });

    // GA4 START event
    player.on('play', function () {
      if (!startFired) { // prevents multiple start events for same play
        window.dataLayer.push({
          event: 'ga4_video_start',
          ga4_data: {
            video_current_time: 0,
            video_duration: Math.floor(player.getDuration()),
            video_percent: 0,
            video_provider: 'JW Player',
            video_title: player.getPlaylistItem().title,
            video_url: player.getPlaylistItem().file,
            visible: player.getViewable()
          }
        });
        startFired = true;
      }
    });

    player.on('seek', function (evt) {
      // This will skip firing of GA4 if the user drags the slider forward
      var dur = player.getDuration();
      var newPct = evt.offset * 100 / dur;
      [25, 50, 75].forEach(function (q) {
        if (newPct >= q) {
          firedQ[q] = true;
        }
      });
    });

    // GA4 PROGRESS event
    player.on('time', function (e) {
      var pct = (e.position * 100) / e.duration;
      [25, 50, 75].forEach(function (q) {
        if (pct >= q && !firedQ[q]) {
          window.dataLayer.push({
            event: 'ga4_video_progress',
            ga4_data: {
              video_current_time: Math.floor(e.position),
              video_duration: Math.floor(e.duration),
              video_percent: q,
              video_provider: 'JW Player',
              video_title: player.getPlaylistItem().title,
              video_url: player.getPlaylistItem().file,
              visible: player.getViewable()
            }
          });
          firedQ[q] = true;
        }
      });
    });

    // GA4 COMPLETE event (reset quartiles and startFired if looping)
    player.on('complete', function () {
      window.dataLayer.push({
        event: 'ga4_video_complete',
        ga4_data: {
          video_current_time: Math.floor(player.getDuration()),
          video_duration: Math.floor(player.getDuration()),
          video_percent: 100,
          video_provider: 'JW Player',
          video_title: player.getPlaylistItem().title,
          video_url: player.getPlaylistItem().file,
          visible: player.getViewable()
        }
      });

      // Reset quartile and startFired flags for any replay (manual or auto-loop)
      firedQ = { 25: false, 50: false, 75: false };
      startFired = false;
    });

    // Stop after 3 loops (if the user restarts the player after looping
    // without refreshing the page, further looping will be disabled).
    player.on('complete', function () {
      currentPlay++;

      if (currentPlay >= 3) {
        player.stop();
      }
    });

    return player;
  }

  // Call the function
  window.setupVideoPlayer = setupVideoPlayer;
})(window, document);